import { useCallback } from 'react';
import * as yup from 'yup';

const useYupValidationResolver = (validationSchema: yup.Schema) =>
  useCallback(
    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    async (data: any) => {
      try {
        const values = await validationSchema.validate(data, {
          abortEarly: false,
        });

        return {
          values,
          errors: {},
        };
      } catch (error) {
        const validationErrors = error as yup.ValidationError;
        return {
          values: {},
          errors: validationErrors.inner.reduce(
            (allErrors, currentError) => ({
              ...allErrors,
              [currentError.path as string]: {
                type: currentError.type ?? 'validation',
                message: currentError.message,
              },
            }),
            {}
          ),
        };
      }
    },
    [validationSchema]
  );

export default useYupValidationResolver;
